<div *ngIf="isShow" class="footer-content">
  <div class="container">
    <div class="row">
      <div class="col-5">
        <h5>
          <span><strong>ỦY BAN NHÂN DÂN HUYỆN CẦN GIỜ,TP HỒ CHÍ MINH</strong></span>
        </h5>
        <ul class="footer-info">
          <li>
            <a>
              <i class="fas fa-home"></i>
              <span>
                Địa chỉ: Đường Lương Văn Nho, Khu phố Giồng Ao, Thị trấn Cần
                Thạnh, Huyện Cần Giờ, Thành phố Hồ Chí Minh
              </span>
            </a>
          </li>
          <li>
            <a>
              <i class="fas fa-phone"></i>
              <span>Tel: (028)3874.0211 - Fax: (028)3874.0211</span>
            </a>
          </li>
          <li>
            <a>
              <i class="far fa-envelope"></i>
              <span>Email: bbt.cangio@tphcm.gov.vn</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-4">
        <h5><b>LIÊN KẾT WEBSITE</b></h5>
        <P>
          <select onchange="window.open(this.value, 'blank_');"
                  style="width: 180px">
            <option value="#">Trang web liên kết</option>
            <option value="http://www.hochiminhcity.gov.vn">
              Hồ Chí Minh CityWeb
            </option>
            <option value="http://www.quan1.hochiminhcity.gov.vn">
              Quận 1
            </option>
            <option value="http://www.quan2.hochiminhcity.gov.vn">
              Quận 2
            </option>
            <option value="http://www.quan3.hochiminhcity.gov.vn">
              Quận 3
            </option>
            <option value="http://www.quan4.hochiminhcity.gov.vn">
              Quận 4
            </option>
            <option value="http://www.quan5.hochiminhcity.gov.vn">
              Quận 5
            </option>
            <option value="http://www.quan6.hochiminhcity.gov.vn">
              Quận 6
            </option>
            <option value="http://www.quan7.hochiminhcity.gov.vn">
              Quận 7
            </option>
            <option value="http://www.quan8.hochiminhcity.gov.vn">
              Quận 8
            </option>
            <option value="http://www.quan9.hochiminhcity.gov.vn">
              Quận 9
            </option>
            <option value="http://www.quan10.hochiminhcity.gov.vn">
              Quận 10
            </option>
            <option value="http://www.quan10.hochiminhcity.gov.vn">
              Quận 11
            </option>
            <option value="http://www.quan12.hochiminhcity.gov.vn">
              Quận 12
            </option>
            <option value="http://www.binhtan.hochiminhcity.gov.vn">
              Quận Bình Tân
            </option>
            <option value="http://www.binhthanh.hochiminhcity.gov.vn">
              Quận Bình Thạnh
            </option>
            <option value="http://www.govap.hochiminhcity.gov.vn">
              Quận Gò Vấp
            </option>
            <option value="http://www.phunhuan.hochiminhcity.gov.vn">
              Quận Phú Nhuận
            </option>
            <option value="http://www.tanbinh.hochiminhcity.gov.vn">
              Quận Tân Bình
            </option>
            <option value="http://www.tanphu.hochiminhcity.gov.vn">
              Quận Tân Phú
            </option>
            <option value="http://www.thuduc.hochiminhcity.gov.vn">
              Quận Thủ Đức
            </option>
            <option value="http://www.binhchanh.hochiminhcity.gov.vn">
              Huyện Bình Chánh
            </option>
            <option value="http://www.cangio.hochiminhcity.gov.vn">
              Huyện Cần Giờ
            </option>
            <option value="http://www.cuchi.hochiminhcity.gov.vn">
              Huyện Củ Chi
            </option>
            <option value="http://www.hocmon.hochiminhcity.gov.vn">
              Huyện Hóc Môn
            </option>
            <option value="http://www.nhabe.hochiminhcity.gov.vn">
              Huyện Nhà Bè
            </option>
          </select>
        </P>
        <p class="store-app-info-top">
          <a class="store-info-item fado-app-btn" href="https://apps.apple.com/vn/app/l%E1%BB%8Bch-h%E1%BB%8Dp-cg/id1580291199" target="_blank">
            <img class=" lazyloaded" src="/assets/images/btn-apple-store.png" alt="" width="96" height="28">
          </a>

          <a class="store-info-item fado-app-btn" href="https://play.google.com/store/apps/details?id=io.ionic.cangiomeeting" target="_blank">
          <!--<a class="store-info-item fado-app-btn" href="https://drive.google.com/file/d/16nBH0JoY6Fq8LoNmR64M3NsfZg6y5aHu/view?usp=sharing" target="_blank">-->
            <img class=" lazyloaded" src="/assets/images/btn-googleplay.png" alt="" width="96" height="28">
          </a>
        </p>
      </div>
      <div class="col" style="text-align: right;">
        <h5>
          <span><strong>LIÊN KẾT VỚI CHÚNG TÔI TẠI</strong></span>
        </h5>
        <div class="link_fac">
          <a href="https://www.facebook.com/" target="_blank">
            <i class="fab fa-facebook-square"></i>
          </a>
          <a href="mailto:cangio@tphcm.gov.vn"><i class="far fa-envelope"></i> </a>
        </div>
      </div>
    </div>
  </div>
</div>
